// ======================================================================
// File Name       : ContentLinkRegister
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Form, Col, Button } from 'react-bootstrap';
import { Field, reduxForm, submit } from 'redux-form';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';

let ContentLinkRegister = (props) => {
  const { contentLink, isEditMode, onRegisterBtnClick, onCancelRegisterBtnClick, handleSubmit } = props;
  const requiredClass = <span className="required">&nbsp;(※)</span>;
  return (
    <div>
      <h3>
        {!isEditMode ? '登録する項目を指定してください' : '編集する項目を指定してください'}
      </h3>
      <Col sm={12} className="padding-top-10">
        <Form onSubmit={handleSubmit(onRegisterBtnClick)} className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              コンテンツ識別ID
            </Col>
            {!isEditMode
              ? <Col sm={7}>
                <RenderField
                  type="text"
                  name="contentSecernId"
                  maxLength="64"
                  label="コンテンツ識別ID"
                  validates={[VALIDATE_TYPE.ID]}
                />
              </Col>
              : <Col sm={7} as={Form.Label} className="padding-left-clear">
                {contentLink.contentSecernId || ''}
              </Col>}
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              コンテンツ名 {requiredClass}
            </Col>
            <Col sm={7}>
              <RenderField
                type="text"
                name="contentName"
                maxLength="256"
                label="コンテンツ名"
                validates={[VALIDATE_TYPE.REQUIRED]}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              リンク先URL {requiredClass}
            </Col>
            <Col sm={7}>
              <RenderField
                type="text"
                name="linkUrl"
                maxLength="2048"
                validates={[VALIDATE_TYPE.REQUIRED]}
                label="リンク先URL"
              />
            </Col>
          </Form.Group>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              {isEditMode && <Button
                variant="default"
                className="btn btn-default btn-96 margin-10"
                onClick={onCancelRegisterBtnClick}
              >
                キャンセル
              </Button>}
              <Button
                variant="primary"
                className="btn-96 margin-10"
                type="submit"
              >
                OK
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Col>
    </div>
  );
};

ContentLinkRegister = reduxForm({
  form: 'contentLinkRegister',
  onSubmit: submit,
  enableReinitialize: true,
  touchOnChange: true,
})(ContentLinkRegister);

ContentLinkRegister = connect((state, ownProps) => ({
  initialValues: ownProps.contentLink,
}))(ContentLinkRegister);

export default ContentLinkRegister;
